module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/~/core-js/modules/_library.js
// module id = 55
// module chunks = 9